import React from 'react';
import Nav from '../components/Nav';
import Hero from '../components/Hero';
import StakeBand from '../components/StakeBand';
import NewsScroll from '../components/NewsScroll';
import Offer from '../components/Offer';
import Silencer from '../components/Silencer';
import Guarantee from '../components/Guarantee';
import WhereItFits from '../components/WhereItFits';
import Process from '../components/Process';
import Assessment from '../components/Assessment';
import Footer from '../components/Footer';
import '../styles/home.css';

/*
 * Section order is the argument:
 *   hero        — what we take on
 *   stake       — how big the problem is         ($150B, abstract)
 *   newsreel    — proof the problem is real      (named towns, live lawsuits)
 *   offer       — what we sell                   (Deploy / Measure / Guarantee)
 *   guarantee   — what is written down           (the four clauses)
 *   silencer  — how the hard two are holdable  (the tone, and our answer)
 *   fits        — whether your plant qualifies
 *   process     — how we start
 *   assessment  — the ask
 *
 * The offer sits directly after the newsreel because that is where the turn
 * happens: the reader has just scrolled through failed installations, and the
 * next thing they should read is that somebody is on the hook for the result.
 *
 * THE SILENCER COMES AFTER THE GUARANTEE, NOT BEFORE IT. Sitting between the
 * offer and the guarantee it was an island of physics between two slabs of
 * contract language, and the register switched twice in three screens. Placed
 * after, it answers the question the guarantee has just raised — how can anyone
 * commit to a tonality clause? — instead of interrupting it. The commercial
 * argument now runs unbroken from the offer to the remedy ladder, and the
 * technology arrives as the reason that argument is credible.
 *
 * The tonal thread is what stitches the two halves together, so it has to stay
 * visible in every section: the stake band names the 50–125 Hz band, the offer
 * splits the paths by whether a tone can get out, the guarantee writes limits
 * against those bands, the silencer is the answer to them, and Where it fits
 * qualifies a site on where its tone actually lands. Cutting it anywhere leaves
 * the seam this order was rearranged to close.
 *
 * Since 2026-08-31 the thread has a second strand: the tone MOVES (blade-pass
 * follows fan speed, which follows load and weather), and the silencer follows
 * it. The hero names it in one line, the stake band says why it matters, the
 * silencer section explains it, and Where it fits and Process each point back
 * at it. Keep the two strands together — "low and moving" is the whole reason
 * the element had to be invented rather than bought.
 */
function Home() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <StakeBand />
        <NewsScroll />
        <Offer />
        <Guarantee />
        <Silencer />
        <WhereItFits />
        <Process />
        <Assessment />
      </main>
      <Footer />
    </>
  );
}

export default Home;
